import { render, staticRenderFns } from "./CustomOJTPage.vue?vue&type=template&id=e07dee08&scoped=true"
import script from "./CustomOJTPage.vue?vue&type=script&lang=js"
export * from "./CustomOJTPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07dee08",
  null
  
)

export default component.exports